
import UTILS from '@/mixins/utils'
export default {
  name: 'TabVertical',
  mixins: [UTILS],
  props: {
    tabVertical: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      show: 0,
    }
  },
  methods: {
    activeItem(index) {
      this.show = index
    },
  },
}
